"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CircleCheckmark(props) {
  let {
    isSelected = false
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: isSelected ? "green.main" : "common.white" // width={24}
    // height={24}
    // alignItems="center"
    // justifyContent="center"
    // borderRadius="circle"
    ,
    br: "circle",
    style: {
      borderColor: isSelected ? "green" : "#BAE6E9",
      borderWidth: 2,
      width: 16,
      height: 16
    }
  });
}

var _default = CircleCheckmark;
exports.default = _default;